import { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/base/ScrollToTop';
import { generateSEOData } from '@/components/feature/SEOHead';

const articleBannerImages: Record<string, string> = {
  'huangyou-xiashuo-chuchu': 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20scrolls%20and%20bamboo%20slips%20with%20calligraphy%2C%20warm%20lighting%2C%20scholarly%20atmosphere%2C%20traditional%20Chinese%20study%20room%2C%20ink%20and%20brush%20on%20wooden%20desk%2C%20soft%20natural%20light%2C%20elegant%20and%20refined%20composition&width=1200&height=600&seq=banner-chuchu-01&orientation=landscape',
  'huangyou-xiashuo-gushi': 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20warrior%20scholar%20in%20traditional%20robes%20holding%20a%20halberd%2C%20ancient%20Chinese%20courtyard%2C%20autumn%20leaves%2C%20misty%20atmosphere%2C%20ink%20wash%20painting%20style%2C%20elegant%20and%20serene%20mood&width=1200&height=600&seq=banner-gushi-01&orientation=landscape',
  'huangyou-xiashuo-xiangzheng': 'https://readdy.ai/api/search-image?query=Symbolic%20ancient%20Chinese%20halberd%20weapon%20resting%20against%20a%20stone%20wall%2C%20soft%20diffused%20lighting%2C%20minimalist%20composition%2C%20ink%20wash%20aesthetic%2C%20serene%20and%20contemplative%20atmosphere&width=1200&height=600&seq=banner-xiangzheng-01&orientation=landscape',
  'huangyou-xiashuo-zhexue': 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20philosophy%20scene%2C%20abstract%20ink%20wash%20landscape%20with%20misty%20mountains%2C%20contemplative%20atmosphere%2C%20Taoist%20philosophy%20concept%2C%20minimalist%20composition%2C%20serene%20and%20profound%20mood&width=1200&height=600&seq=banner-zhexue-01&orientation=landscape',
  'huangyou-xiashuo-tangshi': 'https://readdy.ai/api/search-image?query=Tang%20dynasty%20poetry%20scene%2C%20ancient%20Chinese%20scholar%20writing%20calligraphy%20under%20moonlight%2C%20traditional%20Chinese%20garden%2C%20ink%20wash%20painting%20style%2C%20elegant%20and%20romantic%20atmosphere&width=1200&height=600&seq=banner-tangshi-01&orientation=landscape',
  'huangyou-xiashuo-songci': 'https://readdy.ai/api/search-image?query=Song%20dynasty%20literati%20gathering%2C%20elegant%20Chinese%20garden%20with%20pavilion%2C%20scholars%20reciting%20poetry%2C%20soft%20candlelight%2C%20traditional%20Chinese%20aesthetic%2C%20refined%20and%20cultured%20atmosphere&width=1200&height=600&seq=banner-songci-01&orientation=landscape',
  'huangyou-xiashuo-xiandai': 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20zen%20study%20room%2C%20blend%20of%20traditional%20Chinese%20and%20contemporary%20design%2C%20warm%20natural%20lighting%2C%20peaceful%20and%20contemplative%20atmosphere%2C%20clean%20lines%2C%20serene%20composition&width=1200&height=600&seq=banner-xiandai-01&orientation=landscape',
  'huangyou-xiashuo-yishu': 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20ink%20wash%20painting%20of%20a%20scholar%20in%20landscape%2C%20misty%20mountains%2C%20flowing%20water%2C%20ancient%20pine%20trees%2C%20elegant%20brushwork%2C%20classical%20Chinese%20art%20aesthetic&width=1200&height=600&seq=banner-yishu-01&orientation=landscape',
};

const relatedArticleImages: Record<string, string> = {
  'huangyou-xiashuo-chuchu': 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20scrolls%20and%20bamboo%20slips%20with%20calligraphy%2C%20warm%20lighting%2C%20scholarly%20atmosphere%2C%20traditional%20Chinese%20study%20room%2C%20ink%20and%20brush%20on%20wooden%20desk%2C%20soft%20natural%20light%2C%20elegant%20and%20refined%20composition&width=400&height=280&seq=rel-chuchu-02&orientation=landscape',
  'huangyou-xiashuo-gushi': 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20warrior%20scholar%20in%20traditional%20robes%20holding%20a%20halberd%2C%20ancient%20Chinese%20courtyard%2C%20autumn%20leaves%2C%20misty%20atmosphere%2C%20ink%20wash%20painting%20style%2C%20elegant%20and%20serene%20mood&width=400&height=280&seq=rel-gushi-02&orientation=landscape',
  'huangyou-xiashuo-xiangzheng': 'https://readdy.ai/api/search-image?query=Symbolic%20ancient%20Chinese%20halberd%20weapon%20resting%20against%20a%20stone%20wall%2C%20soft%20diffused%20lighting%2C%20minimalist%20composition%2C%20ink%20wash%20aesthetic%2C%20serene%20and%20contemplative%20atmosphere&width=400&height=280&seq=rel-xiangzheng-02&orientation=landscape',
  'huangyou-xiashuo-zhexue': 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20philosophy%20scene%2C%20abstract%20ink%20wash%20landscape%20with%20misty%20mountains%2C%20contemplative%20atmosphere%2C%20Taoist%20philosophy%20concept%2C%20minimalist%20composition%2C%20serene%20and%20profound%20mood&width=400&height=280&seq=rel-zhexue-02&orientation=landscape',
  'huangyou-xiashuo-tangshi': 'https://readdy.ai/api/search-image?query=Tang%20dynasty%20poetry%20scene%2C%20ancient%20Chinese%20scholar%20writing%20calligraphy%20under%20moonlight%2C%20traditional%20Chinese%20garden%2C%20ink%20wash%20painting%20style%2C%20elegant%20and%20romantic%20atmosphere&width=400&height=280&seq=rel-tangshi-02&orientation=landscape',
  'huangyou-xiashuo-songci': 'https://readdy.ai/api/search-image?query=Song%20dynasty%20literati%20gathering%2C%20elegant%20Chinese%20garden%20with%20pavilion%2C%20scholars%20reciting%20poetry%2C%20soft%20candlelight%2C%20traditional%20Chinese%20aesthetic%2C%20refined%20and%20cultured%20atmosphere&width=400&height=280&seq=rel-songci-02&orientation=landscape',
  'huangyou-xiashuo-xiandai': 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20zen%20study%20room%2C%20blend%20of%20traditional%20Chinese%20and%20contemporary%20design%2C%20warm%20natural%20lighting%2C%20peaceful%20and%20contemplative%20atmosphere%2C%20clean%20lines%2C%20serene%20composition&width=400&height=280&seq=rel-xiandai-02&orientation=landscape',
  'huangyou-xiashuo-yishu': 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20ink%20wash%20painting%20of%20a%20scholar%20in%20landscape%2C%20misty%20mountains%2C%20flowing%20water%2C%20ancient%20pine%20trees%2C%20elegant%20brushwork%2C%20classical%20Chinese%20art%20aesthetic&width=400&height=280&seq=rel-yishu-02&orientation=landscape',
};

export default function ArticlePage() {
  const { slug } = useParams<{ slug: string }>();
  const article = articles.find((a) => a.id === slug);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [slug]);

  if (!article) {
    return (
      <>
        <Navbar />
        <main className="pt-16 min-h-screen flex items-center justify-center">
          <div className="text-center">
            <h1 className="font-heading text-2xl font-bold text-foreground-900 mb-4">
              文章未找到
            </h1>
            <p className="text-foreground-500 mb-6">您访问的文章可能已被移除或链接有误。</p>
            <Link
              to="/"
              className="px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full font-medium text-sm transition-colors whitespace-nowrap"
            >
              返回首页
            </Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  const relatedArticles = articles
    .filter((a) => a.categorySlug === article.categorySlug && a.id !== article.id)
    .slice(0, 3);

  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Article',
        headline: article.title,
        description: article.excerpt,
        author: { '@type': 'Person', name: article.author },
        datePublished: article.publishDate,
        url: `https://huangyouxiaji.com/article/${article.id}`,
        articleSection: article.category,
        keywords: article.tags.join(','),
      },
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: 'https://huangyouxiaji.com' },
          { '@type': 'ListItem', position: 2, name: article.category, item: `https://huangyouxiaji.com/category/${article.categorySlug}` },
          { '@type': 'ListItem', position: 3, name: article.title },
        ],
      },
    ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <Navbar />
      <main className="pt-16">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', path: '/' },
              { label: article.category, path: `/category/${article.categorySlug}` },
              { label: article.title },
            ]}
          />
        </div>

        <article className="max-w-4xl mx-auto px-4 md:px-6 py-8 md:py-12">
          <header className="mb-8">
            <div className="flex items-center gap-3 mb-4">
              <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700">
                {article.category}
              </span>
              <span className="text-foreground-400 text-xs">{article.publishDate}</span>
              <span className="text-foreground-400 text-xs">·</span>
              <span className="text-foreground-400 text-xs">{article.readTime} 分钟阅读</span>
            </div>
            <h1 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-4 leading-tight">
              {article.title}
            </h1>
            <p className="text-foreground-500 text-base leading-relaxed">
              {article.excerpt}
            </p>
            <div className="flex items-center gap-2 mt-4">
              <span className="text-sm text-foreground-600">作者：{article.author}</span>
            </div>
          </header>

          <div className="w-full h-64 md:h-80 rounded-xl overflow-hidden mb-10">
            <img
              src={articleBannerImages[article.id] || ''}
              alt={article.title}
              className="w-full h-full object-cover object-top"
            />
          </div>

          <div
            className="article-content"
            dangerouslySetInnerHTML={{ __html: article.content }}
          />

          <div className="mt-10 pt-8 border-t border-background-200">
            <div className="flex flex-wrap gap-2">
              {article.tags.map((tag) => (
                <span
                  key={tag}
                  className="px-3 py-1.5 rounded-full text-xs font-medium bg-background-100 text-foreground-600 border border-background-200/70"
                >
                  #{tag}
                </span>
              ))}
            </div>
          </div>
        </article>

        {relatedArticles.length > 0 && (
          <section className="bg-background-100 py-12 md:py-16">
            <div className="max-w-4xl mx-auto px-4 md:px-6">
              <h2 className="font-heading text-xl font-bold text-foreground-900 mb-8">
                相关文章
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {relatedArticles.map((rel) => (
                  <Link
                    key={rel.id}
                    to={`/article/${rel.id}`}
                    className="group rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 overflow-hidden transition-all duration-300 cursor-pointer"
                  >
                    <div className="w-full h-40 overflow-hidden">
                      <img
                        src={relatedArticleImages[rel.id] || ''}
                        alt={rel.title}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      />
                    </div>
                    <div className="p-4">
                      <h3 className="font-heading font-semibold text-sm text-foreground-900 mb-1 group-hover:text-primary-600 transition-colors line-clamp-2">
                        {rel.title}
                      </h3>
                      <span className="text-xs text-foreground-400">{rel.publishDate}</span>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </section>
        )}
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}